<div class="footer-container">
    <label class="footer-text">Copyright © 2011 - 2024 The 1947 Partition Archive. All rights reserved.</label>
</div>
